var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-page--single"},[_c('bread-crumb',{attrs:{"breadcrumb":_vm.breadCrumb}}),_vm._v(" "),_c('div',{staticClass:"ps-section--custom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"ps-section__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.varhtml)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }